// MYSPACE COMMON COMPONENTS
window.ReactRootComponents = {}

//// Form
import GcInputPasswordRoot from './components/form/GcInputPasswordRoot.jsx';
import LocationsSelectorRoot from './components/form/LocationsSelectorRoot.jsx';
import DispositionsSelectorRoot from './components/form/DispositionsSelectorRoot.jsx';
import ConfigureProductFormRoot from './components/form/ConfigureProductFormRoot.jsx';
import ConfigurePackageFormRoot from './components/form/ConfigurePackageFormRoot.jsx';
import HotelsGroupsSelectorRoot from './components/form/HotelsGroupsSelectorRoot.jsx';
import ExternalCRMClientsSelectorRoot from './components/form/ExternalCRMClientsSelectorRoot.jsx';
import ExternalCRMCompaniesSelectorRoot from './components/form/ExternalCRMCompaniesSelectorRoot.jsx';
import TextareaCodeEditorRoot from './components/form/TextareaCodeEditorRoot.jsx';
import ButtonDownloadExtractRoot from './components/form/ButtonDownloadExtractRoot.jsx';

// ACCOUNT COMPONENTS
//// Billing Address
import BillingAddressRoot from './components/myspace/common/account/billing_address/BillingAddressRoot.jsx';
import BillingAddressCardRoot from './components/myspace/common/account/billing_address/BillingAddressCardRoot.jsx';
import BillingAddressSelectRoot from './components/myspace/common/account/billing_address/BillingAddressSelectRoot.jsx';
import BillingAddressSelectCongressRoot from './components/myspace/common/account/billing_address/BillingAddressSelectCongressRoot.jsx';

import NotificationsRoot from './components/myspace/common/NotificationsRoot.jsx';

//// Requests
import FinalClientRoot from './components/myspace/common/requests/final_client/FinalClientRoot.jsx';

//// RequestsHotels
import RequestsHotelsSimpleRoot from './components/myspace/common/requests_hotels/RequestsHotelsSimpleRoot.jsx';

//// Hotels
import SpecialOffersLivePreviewRoot from './components/myspace/common/hotels/special_offers/SpecialOffersLivePreviewRoot.jsx';

//// Contrats cadres
import FrameworkAgreementsRoot from './components/myspace/common/framework_agreements/FrameworkAgreementsRoot.jsx';
import FrameworkAgreementsDetailsRoot from './components/myspace/common/framework_agreements/FrameworkAgreementsDetailsRoot.jsx';
import FrameworkAgreementsKpisRoot from './components/myspace/common/framework_agreements/FrameworkAgreementsKpisRoot.jsx';

import RefreshContainerRoot from './components/myspace/common/RefreshContainerRoot.tsx';